<template>
  <base-page-layout title="Faturamento diário" :filters="['lojas', 'pessoa', 'clube', 'segmentos', 'produtos']">
    <diario-data-table :listaFaturamento="listaFaturamento" />
    <diario-faturamento-chart :lista="listaFaturamento" />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import DiarioDataTable from '@/modules/empresa/faturamento/views/pages/DiarioDataTable.vue'
import DiarioFaturamentoChart from '@/modules/empresa/faturamento/views/pages/DiarioFaturamentoChart.vue'
import { mapActions, mapState } from 'vuex'
import { assertArray } from '@/config/helpers.js'
import { DateTime } from 'luxon'
import capitalize from 'lodash/capitalize'

export default {
  components: {
    BasePageLayout,
    DiarioDataTable,
    DiarioFaturamentoChart,
  },
  data: () => ({
    listaFaturamento: [],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
  },
  async mounted() {
    const hasPrefilter = this.$route.query.is_prefilter
    if (!hasPrefilter) await this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapActions(['empresaFaturamento']),
    async getData() {
      const filter = {
        fidelidade: this.stateFilters.fidelidade,
        unidades: this.stateFilters.unitsConfiguration,
        tipo_pessoa: this.stateFilters.pessoa,
        categoria_cliente: this.stateFilters.cliente,
        group_field: 'dia',
        date: this.$route.params.mes,
        segmentos: this.stateFilters.segments,
        produto: this.stateFilters.products,
      }

      const faturamento = await this.empresaFaturamento(filter)
      this.listaFaturamento = assertArray(faturamento).map((obj) => {
        obj['NUM_SEMANA'] = this.getDayOfWeek(obj['NUM_DIA'])
        obj['NUM_DIA_PAD'] = obj['NUM_DIA'].toString().padStart(2, '0')
        return obj
      })
    },
    getDayOfWeek(dayNumber) {
      const yearD = DateTime.fromFormat(this.$route.params.mes, 'yyyy-MM').toFormat('yyyy')
      const monthD = DateTime.fromFormat(this.$route.params.mes, 'yyyy-MM').toFormat('MM')

      return capitalize(DateTime.fromObject({ year: yearD, month: monthD, day: dayNumber }).setLocale('pt-BR').toFormat('cccc'))
    },
  },
}
</script>
